<template>
  <div>
    <div class="numul">
      <ul>
        <li>
          <div class="ball">{{ drawList[0] }}</div>
        </li>
        <li class="ball">
          {{ drawList[1] }}
        </li>
        <li class="ball">
          {{ drawList[2] }}
        </li>
      </ul>
      <!-- <div v-for="(item,index) in drawList" :key="index">
      <img :class="types=='home'?'homeimg':'lotteryimg'" v-if="item" :src="lotteryimg['touzi'+item]" alt />
    </div> -->
    </div>
    <div class="smalltable" v-if="types == 'home'">
      <table
        cellpadding="0"
        cellspacing="0"
        border="0"
        style="
          width: 100%;
          textalign: center;
          border-top: solid 1px #e5e5e5;
          border-left: solid 1px #e5e5e5;
          text-align: center;
        "
      >
        <tr>
          <td
            style="
              border-right: solid 1px #e5e5e5;
              border-bottom: solid 1px #e5e5e5;
              color: #de0846;
            "
            height="30"
            colspan="3"
          >
            总和
          </td>
        </tr>
        <tr>
          <td
            style="
              border-right: solid 1px #e5e5e5;
              border-bottom: solid 1px #e5e5e5;
            "
            width="140"
            height="30"
            v-for="(item, index) in drawingNumbertool"
            :key="index"
          >
            {{ item }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import lotteryRandBall from "~/mixins/lotteryRandBall.mixins";

export default {
  mixins: [lotteryRandBall],
  data() {
    return {};
  },
  computed: {
    drawingNumbertool() {
      let tool = [];
      let { drawingNumber } = this;
      if (drawingNumber.length <= 1) {
        drawingNumber = this.randList;
      }
      let add = drawingNumber.reduce((a, b) => a * 1 + b * 1);
      tool.push(add);
      if (add > 13) {
        tool.push("大");
      } else {
        tool.push("小");
      }
      if (add % 2 == 0) {
        tool.push("双");
      } else {
        tool.push("单");
      }
      return tool;
    },
  },
};
</script>

<style lang="less" scoped>
.numul {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 16px;
  height: 56px;
  ul {
    display: flex;
    height: 56px;
    .ball {
      display: block;
      width: 36px;
      height: 36px;
      line-height: 36px;
      font-size: 18px;
      font-weight: 700;
      color: #000;
      text-align: center;
      background: #fafafb;
      background-image: linear-gradient(1turn, #d5d5d5 10%, #fff);
      box-shadow: 1px 3px 6px 0px rgb(0 0 0 / 50%);
      margin-right: 6px;
      border-radius: 50%;
    }
  }
  .lotteryimg {
    width: 36px;
    line-height: 36px;
    height: 36px;
    margin: 0 8px;
  }
  .homeimg {
    width: 36px;
    line-height: 36px;
    height: 36px;
    margin: 0 5px;
  }
}
</style>